import React, { useState } from "react";
import * as Yup from "yup";

import Table from "components/Table";
import Filter from "@Components/Filter";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { AUDIT_EXCEL_LOG_URL } from "configs/constants";

let model = [
    { id: "date", label: "Date", type: "string" },
    { id: "File", label: "File", type: "string" },
    { id: "taskaction", label: "TaskAction", type: "string" },

    


];

const actions = [
  {
    type: "download",
    title: "Download",
    icon: <CloudDownloadIcon style={{ color: "red" }} />,
    // onClick: (id, record) => downloadLedger(id, record),
  },
];
  const validationSchema = Yup.object({
  
    requested_date: Yup.string()
      .required("API date is required")
      .typeError("Invalid API date"),
   
  });


const filterInitialValues = {
    requested_date: null,
    source: "",
 
};

const AuditLogExcel = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);

  const filterFields = [
    {
      type: "datepicker",
      label: "Requested Date",
      name: "requested_date",
      required:true,

    },
   
  
    
   
  
    
    
  ];
  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        validationSchema={validationSchema}


      />
            {filtersApplied ? (

      <Table
        proxyURL= {AUDIT_EXCEL_LOG_URL}
        model={model}
        exportUrl="url"
        filterValues={filterValues}
        noFilter
        actions={actions}

        noAddButton
      />
      ) : (
        <Table
        proxyURL={null}
        model={model}
        exportUrl="url"
        filterValues={filterValues}
        noFilter
        actions={actions}

        noAddButton
      />
      )}
    </>
  );
};
export default AuditLogExcel;
